import { render, staticRenderFns } from "./AcknowledgeHandoff.vue?vue&type=template&id=66e28fbf"
import script from "./AcknowledgeHandoff.vue?vue&type=script&lang=js"
export * from "./AcknowledgeHandoff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports